import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "tiers-section" }
const _hoisted_2 = { class: "tiers-section" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_HeaderMessengerButton = _resolveComponent("HeaderMessengerButton")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, {
        class: _normalizeClass(["ion-no-border events-page-header", { 'page-header--scrolled': _ctx.headerScrolled }])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    text: "",
                    "default-href": _ctx.backHref
                  }, null, 8, ["default-href"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isNew ? 'Новая подписка' : 'Редактирование'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_HeaderMessengerButton)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_ion_content, {
        class: "main-background events-content",
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createElementVNode("form", {
            class: "ion-padding event-edit-form",
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)), ["prevent"]))
          }, [
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("Название *", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  modelValue: _ctx.form.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.title) = $event)),
                  required: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("Описание", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_textarea, {
                  modelValue: _ctx.form.description,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.description) = $event)),
                  rows: 4
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { position: "stacked" }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode("Срок действия (дней) *", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  type: "number",
                  modelValue: _ctx.form.durationDays,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.durationDays) = $event)),
                  modelModifiers: { number: true },
                  min: "1",
                  required: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_ion_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toggle, {
                  modelValue: _ctx.form.published,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.published) = $event))
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("Опубликовано (видно пользователям)", -1)
                  ]))]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_1, [
              _cache[14] || (_cache[14] = _createElementVNode("h3", null, "Тарифы", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.priceTiers, (t, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: i,
                  class: "tier-row"
                }, [
                  _createVNode(_component_ion_input, {
                    modelValue: t.name,
                    "onUpdate:modelValue": ($event: any) => ((t.name) = $event),
                    class: "tier-input-name",
                    placeholder: "Название тарифа"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_ion_input, {
                    type: "number",
                    modelValue: t.amountRub,
                    "onUpdate:modelValue": ($event: any) => ((t.amountRub) = $event),
                    modelModifiers: { number: true },
                    class: "tier-input-amount",
                    placeholder: "₽",
                    min: "0"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_ion_select, {
                    modelValue: t.requiredAuthorityName,
                    "onUpdate:modelValue": ($event: any) => ((t.requiredAuthorityName) = $event),
                    class: "tier-role-select",
                    interface: "popover",
                    placeholder: "Роль (необяз.)",
                    "cancel-text": "Отмена"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_select_option, { value: null }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("—", -1)
                        ]))]),
                        _: 1
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorities, (a) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: a.name,
                          value: a.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(a.description || a.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode(_component_ion_button, {
                    fill: "clear",
                    size: "small",
                    class: "tier-row-remove",
                    onClick: ($event: any) => (_ctx.removeTier(i))
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("×", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ]))
              }), 128)),
              _createVNode(_component_ion_button, {
                fill: "outline",
                size: "small",
                class: "tier-add-btn",
                onClick: _ctx.addTier
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("+ Тариф", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_2, [
              _cache[15] || (_cache[15] = _createElementVNode("h3", null, "Роли при покупке", -1)),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_select, {
                    label: "Выдаваемые роли",
                    "label-placement": "stacked",
                    modelValue: _ctx.form.giftAuthorityNames,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.giftAuthorityNames) = $event)),
                    multiple: "",
                    interface: "alert",
                    "cancel-text": "Отмена",
                    "ok-text": "Готово",
                    placeholder: "Выберите роли"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authorities, (a) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: 'gift-' + a.name,
                          value: a.name
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(a.description || a.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            (!_ctx.isNew && _ctx.subscriptionId)
              ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, null, {
                      default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                        _createTextVNode("Логотип", -1)
                      ]))]),
                      _: 1
                    }),
                    _createElementVNode("input", {
                      type: "file",
                      accept: "image/*",
                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onLogoChange && _ctx.onLogoChange(...args))),
                      ref: "logoInput",
                      style: {"display":"none"}
                    }, null, 544),
                    _createVNode(_component_ion_button, {
                      fill: "outline",
                      onClick: _ctx.openLogoPicker
                    }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode("Загрузить", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"]),
                    (_ctx.logoPreview)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.logoPreview,
                          class: "logo-preview",
                          alt: ""
                        }, null, 8, _hoisted_3))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_button, {
              expand: "block",
              type: "submit",
              disabled: _ctx.saving,
              class: "save-event-btn ion-margin-top"
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode("Сохранить", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            (!_ctx.isNew)
              ? (_openBlock(), _createBlock(_component_ion_button, {
                  key: 1,
                  expand: "block",
                  color: "danger",
                  fill: "outline",
                  disabled: _ctx.saving,
                  onClick: _ctx.remove,
                  class: "ion-margin-top"
                }, {
                  default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createTextVNode(" Удалить подписку ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"]))
              : _createCommentVNode("", true)
          ], 32)
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}